import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import DataTable from 'components/shared/DataTable';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import ICON_COMMON from 'utils/icons.common';

import { showConfirmModal } from 'actions/global';
import { InputNumber } from 'antd';
import ErrorMessage from 'components/shared/BWFormControl/ErrorMessage';
import FormNumber from 'components/shared/BWFormControl/FormNumber';
import _get from 'lodash/get';
import { TYPE_PROMOTION_VALUE } from 'pages/Coupon/utils/constants';
import { PromotionnalSchema } from 'pages/Coupon/utils/contructor';
import { formatNumber, validateDulicate } from 'pages/Coupon/utils/utils';
import { Controller, useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const CouponPromotional = ({ loading, title, disabled, messageErr }) => {
  const methods = useFormContext();
  const {
    formState: { errors },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: 'promotional_list',
    rules: {
      required: 'Giá trị khuyến mãi là bắt buộc',
      validate: (listPromotion = []) => {
        const totalPercent = listPromotion.reduce((totalPercent, currentPromotion) => {
          return totalPercent + currentPromotion?.percent_value;
        }, 0);
        if (totalPercent > 100) {
          return 'Đã vượt quá ngân sách';
        }
        if (!validateDulicate(listPromotion)) {
          return 'Mã khuyến mãi không được trùng nhau';
        }
      },
    },
  });
  const dispatch = useDispatch();

  const totalBuget = useWatch({ name: 'budget' });

  const columns = [
    {
      header: 'Mã khuyến mãi',
      formatter: (_, index) => {
        return (
          <React.Fragment>
            <Controller
              control={methods.control}
              name={`promotional_list.${index}.coupon_code`}
              rules={{
                required: 'Mã khuyến mãi là bắt buộc',
              }}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <>
                  <FormInput
                    style={{
                      padding: '5px',
                      border: '1px solid #ccc',
                      borderRadius: '6px',
                    }}
                    disabled={disabled}
                    type='text'
                    placeholder='Mã khuyến mãi'
                    value={value ? value.toUpperCase() : ''}
                    onChange={onChange}
                  />
                  {error && <ErrorMessage message={error?.message} />}
                </>
              )}
            />
          </React.Fragment>
        );
      },
    },
    {
      header: 'Tỉ lệ / Ngân sách',
      formatter: (_, index) => {
        return (
          <>
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}>
              <Controller
                control={methods.control}
                name={`promotional_list.${index}.percent_value`}
                rules={{
                  required: 'Tỉ lệ / ngân sách là bắt buộc',
                  max: { value: 100, message: 'Đã vượt quá ngân sách' },
                }}
                render={({ field: { value, onChange }, fieldState: { error } }) => (
                  <InputNumber
                    controls={false}
                    value={value}
                    onChange={onChange}
                    onBlur={() => {
                      methods.setValue(`promotional_list.${index}.code_value`, undefined);
                      methods.setValue(`promotional_list.${index}.quantity`, undefined);
                    }}
                    disabled={disabled}
                  />
                )}
              />
              <span style={{ marginLeft: '5px' }}>%</span>
            </div>
            {errors && <ErrorMessage message={_get(errors, `promotional_list.${index}.percent_value.message`, '')} />}
          </>
        );
      },
    },

    {
      header: 'Tổng ngân sách',
      classNameBody: 'bw_text_right',
      formatter: () => `${formatNumber(totalBuget)} đ`,
    },
    {
      header: 'Tổng giá trị khuyến mãi',
      classNameBody: 'bw_text_right',
      formatter: (_, index) => {
        const totalCouponValue =
          (methods.watch(`promotional_list.${index}.percent_value`) * methods.watch('budget')) / 100;
        return `${formatNumber(totalCouponValue)} đ`;
      },
    },
    {
      header: 'Giá trị / Mã khuyến mãi',
      classNameBody: 'bw_text_right',
      formatter: (_, index) => {
        const totalCouponValue =
          (methods.watch(`promotional_list.${index}.percent_value`) * methods.watch('budget')) / 100;
        return (
          <>
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}>
              <Controller
                control={methods.control}
                name={`promotional_list.${index}.code_value`}
                rules={{ required: 'Giá trị / mã khuyến mãi là bắt buộc' }}
                render={({ field: { value, onChange } }) => (
                  <FormNumber
                    min={0}
                    controls={false}
                    value={value}
                    onChange={onChange}
                    onBlur={() => {
                      if (value) {
                        const newQuantityCoupon = Math.floor(totalCouponValue / parseInt(value));
                        methods.setValue(`promotional_list.${index}.quantity`, newQuantityCoupon);
                      }
                    }}
                    disabled={disabled || !totalCouponValue}
                  />
                )}
              />
              <span style={{ marginLeft: '5px' }}>đ</span>
            </div>
            {errors && <ErrorMessage message={_get(errors, `promotional_list.${index}.code_value.message`, '')} />}
          </>
        );
      },
    },
    {
      header: 'Số lượng mã',
      formatter: (_, index) => {
        const totalCouponValue =
          (methods.watch(`promotional_list.${index}.percent_value`) * methods.watch('budget')) / 100;
        return (
          <>
            <Controller
              style={{
                width: '100%',
              }}
              control={methods.control}
              name={`promotional_list.${index}.quantity`}
              rules={{ required: 'Số lượng mã là bắt buộc' }}
              render={({ field: { value, onChange } }) => (
                <InputNumber
                  style={{
                    width: '100%',
                    paddingRight: '15px',
                  }}
                  min={0}
                  value={value}
                  onChange={onChange}
                  disabled={disabled || !totalCouponValue}
                  onBlur={() => {
                    if (value) {
                      const newCouponCodeValue = Math.floor(totalCouponValue / value);
                      methods.setValue(`promotional_list.${index}.code_value`, newCouponCodeValue);
                    }
                  }}
                />
              )}
            />
            {errors && <ErrorMessage message={_get(errors, `promotional_list.${index}.quantity.message`, '')} />}
          </>
        );
      },
    },
    {
      header: 'Điều kiện áp dụng',
      formatter: (_, index) => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}>
            <div>
              <FormNumber
                style={{
                  width: '100px',
                }}
                defaultValue={0}
                disabled={disabled}
                field={`promotional_list.${index}.min_total_money`}
                placeholder='Giá trị tối thiểu'
                // validation={{
                //   required: 'Giá trị tối thiểu là bắt buộc',
                // }}
              />
            </div>
            <span
              style={{
                padding: '5px 5px',
                alignSelf: 'flex-start',
              }}>
              →
            </span>
            <div
              style={{
                alignSelf: 'flex-start',
              }}>
              <FormNumber
                style={{
                  width: '100px',
                }}
                placeholder='Giá trị tối đa'
                disabled={disabled}
                type='text'
                field={`promotional_list.${index}.max_total_money`}
              />
              <span style={{ marginLeft: '5px' }}>đ</span>
            </div>
          </div>
        );
      },
    },
    // {
    //   header: 'Giảm tối đa',
    //   formatter: (_, index) => {
    //     return (
    //       <FormNumber
    //         type='number'
    //         style={{
    //           border: '1px solid #ccc',
    //           borderRadius: '6px',
    //         }}
    //         max={methods.watch(`promotional_list.${index}.codeValue`)}
    //         disabled={disabled || methods.watch(`promotional_list.${index}.code_type`) === TYPE_PROMOTION_VALUE.MONEY}
    //         field={`promotional_list.${index}.max_value_reduce`}
    //         placeholder='Giá trị giảm tối đa'
    //       />
    //     );
    //   },
    // },
  ];

  const isCheckTotalCoupon = Boolean(methods.watch('budget'));

  const promotionalRatioValue = (methods.watch('promotional_list') ?? []).reduce(function (acc, obj) {
    return acc + obj.percent_value;
  }, 0);

  const actions = useMemo(() => {
    return [
      {
        globalAction: true,
        icon: ICON_COMMON.add,
        type: 'success',
        content: 'Thêm dòng',
        hidden: disabled || !totalBuget,
        onClick: () => {
          if (isCheckTotalCoupon) {
            if (promotionalRatioValue >= 100) {
              toast.error('Tỉ lệ  khuyến mãi đã bằng 100%', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
              });
              return;
            }
            append(new PromotionnalSchema(TYPE_PROMOTION_VALUE.MONEY));
          } else {
            toast.error('Vui lòng nhập giá trị Ngân sách', {
              position: 'top-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'colored',
            });
          }
        },
      },
      {
        icon: ICON_COMMON.trash,
        hidden: disabled,
        color: 'red',
        onClick: (value, index) => {
          dispatch(
            showConfirmModal([`Xoá mã khuyến mãi này?`], () => {
              remove(index);
            }),
          );
        },
      },
    ];
  }, [isCheckTotalCoupon, promotionalRatioValue]);

  return (
    <React.Fragment>
      <BWAccordion isRequired title={title}>
        <p>
          <b>Lưu ý:</b> Tổng tỉ lệ / Ngân sách không vượt quá 100%
        </p>
        <DataTable
          style={{
            marginTop: '0px',
          }}
          hiddenActionRow
          noPaging
          noSelect
          data={fields}
          columns={columns}
          loading={loading}
          actions={actions}
        />
        {messageErr && <ErrorMessage message={messageErr} />}
        {errors && <ErrorMessage message={_get(errors, 'promotional_list.root.message', '')} />}
      </BWAccordion>
    </React.Fragment>
  );
};

CouponPromotional.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CouponPromotional;
